var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8656 20.28C16.8856 21.23 15.8156 21.08 14.7856 20.63C13.6956 20.17 12.6956 20.15 11.5456 20.63C10.1056 21.25 9.34559 21.07 8.48559 20.28C3.60559 15.25 4.32559 7.59 9.86559 7.31C11.2156 7.38 12.1556 8.05 12.9456 8.11C14.1256 7.87 15.2556 7.18 16.5156 7.27C18.0256 7.39 19.1656 7.99 19.9156 9.07C16.7956 10.94 17.5356 15.05 20.3956 16.2C19.8256 17.7 19.0856 19.19 17.8556 20.29L17.8656 20.28ZM12.8456 7.25C12.6956 5.02 14.5056 3.18 16.5856 3C16.8756 5.58 14.2456 7.5 12.8456 7.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.1e0f2faf785b1247153add46c51a5610.svg";
export { ForwardRef as ReactComponent };